module.exports = __webpack_public_path__ + "static/other/starball.d8f1187f.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/starball.json
// module id = 2642
// module chunks = 0